import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SelectedDataService {

  constructor() { }

  public year: number;
}
